import { useMemo } from 'react';
import type { ScopedPortalItem } from 'components/MapPage/CorporateViewTabs/LayersTab/arcgis-integration/arcGisPortal';
import { useDhsLayers } from './arcgis-integration/useDhsLayers';
import {
  PortalItemRow,
  SelectablePortalItemsList,
} from './SelectablePortalItemsList';

type AddDhsLayerProps = {
  selectedItemIds: Set<string>;
  onToggleItem: (item: ScopedPortalItem, checked: boolean) => void;
  onToggleAllItems: (items: ScopedPortalItem[], checked: boolean) => void;
};

export function AddDhsLayer({
  selectedItemIds,
  onToggleItem,
  onToggleAllItems,
}: AddDhsLayerProps) {
  const { data = [] } = useDhsLayers();

  const dhsItems = useMemo(() => data, [data]);

  return (
    <SelectablePortalItemsList
      items={dhsItems}
      selectedItemIds={selectedItemIds}
      onToggleAllItems={onToggleAllItems}
    >
      {(filteredItems) => (
        <div className="table-responsive">
          <table className="table table-sm align-middle mb-0">
            <thead>
              <tr>
                <th className="ps-0">Title</th>
                <th className="ps-0">Preview</th>
              </tr>
            </thead>
            <tbody>
              {filteredItems.map((item, index) => (
                <tr key={item.id ?? `dhs-item-${index}`}>
                  <PortalItemRow
                    item={item}
                    selectedItemIds={selectedItemIds}
                    onToggleItem={onToggleItem}
                  />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </SelectablePortalItemsList>
  );
}
